// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3lMh3","title":"Header_title__2gz1p","side":"Header_side__wffWO"};